import Big from "big.js";
import {numberToChinese} from "@/utils/ruoyi.js";

// 题目39对应的初始数据--数据转换
export function convertBaseData(initialData) {
    return initialData.reduce((prev, row) => {
        const find = prev.find(s => s.item.allInvoiceNumber == row.item.allInvoiceNumber)

        const jsHj = parseFloat(new Big(row?.item?.amount || 0).plus(row?.item?.taxAmount || 0).toString()) // 当前价税合计
        // 不存在则添加一条
        if (!find) {
            prev.push({
                seller: {
                    taxRegistrationNo: row.seller.taxRegistrationNo,
                    name: row.seller.name,
                },
                buyer: {
                    name: row.buyer.name,
                    taxRegistrationNo: row.buyer.taxRegistrationNo,
                },
                item: {
                    allInvoiceNumber: row.item.allInvoiceNumber,
                    amount: row.item.amount,
                    taxAmount: row.item.taxAmount,
                    jsHj,
                    jsHj_Big: numberToChinese(jsHj),
                },
                kaijuStatus: row.kaijuStatus,
                hzMakeDate: row.hzMakeDate,
                addUsageCheck: row.addUsageCheck,
                consumeUsageCheck: row.consumeUsageCheck,
                accountStatus: row.accountStatus,
                originRows: [row], // 存原始这一组的数据
            })
        } else {
            find.originRows.push(row)
            find.item.amount = parseFloat(new Big(row.item.amount).plus(find.item.amount).valueOf()) // 金额、税额相加
            find.item.taxAmount = parseFloat(new Big(row.item.taxAmount).plus(find.item.taxAmount).valueOf())

            const al = parseFloat(new Big(jsHj).plus(find.item.jsHj).valueOf())
            find.item.jsHj = al
            find.item.jsHj_Big = numberToChinese(al)
        }
        return prev
    }, [])
}

// 题目39保存hook。
export function useSave39Qa(currentQa, currentRow) {

    let currentSaveTag = ref(0) //0默认  1确认   2拒绝

    const getGrandchildValue = inject("getGrandchildValue");
    getGrandchildValue.value.getData = (byUser) => {

        if (!Boolean(byUser)) { // 非用户主动保存数据，不触发修改solution，即不保存
            return {}
        }
        const alreadySo = currentQa.value.solution && JSON.parse(currentQa.value.solution)?.userAnswer || []
        if (currentSaveTag.value == 1) { // 确认
            const idx = alreadySo.findIndex(f => f.allInvoiceNumber == currentRow.value.item.allInvoiceNumber)
            const currentNewData = {
                allInvoiceNumber: currentRow.value.item.allInvoiceNumber,
                otherSideName: currentRow.value.seller.name,
                otherSideCode: currentRow.value.seller.taxRegistrationNo,
                totalAmount: currentRow.value.item.amount,
                totalTaxAmount: currentRow.value.item.taxAmount,
                kaijuStatus: currentRow.value.kaijuStatus,
                originData: currentRow.value, // 原始发票信息数据
            }
            if (idx > -1) { // 找到了，删除重新加
                alreadySo.splice(idx, 1, currentNewData)
            } else { // 没找到，答案添加进去
                alreadySo.push(currentNewData)
            }
        } else if (currentSaveTag.value == 2) { // 拒绝，则为移除
            const idx = alreadySo.findIndex(f => f.allInvoiceNumber == currentRow.value.item.allInvoiceNumber)
            if (idx > -1) {
                alreadySo.splice(idx, 1)
            }
        }
        return {
            solution: JSON.stringify({
                userAnswer: alreadySo || [],
            }),
        };
    };

    getGrandchildValue.value.getResetData = () => {
        return {
            solution: "",
        };
    };

    return {
        currentSaveTag,
    }
}
